import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import { I18n } from 'react-redux-i18n'

import api from 'core/api'

export const enableThunk = createActionThunk('OTP_ENABLE', api('/otp/enable', { method: 'PUT' }))

export const enable = props => dispatch =>
  dispatch(enableThunk(props))
    .then(() => dispatch(toastr.add({ type: 'success', message: I18n.t('otp.notice.enabled') })))
    .catch(() =>
      dispatch(toastr.add({ type: 'error', message: I18n.t('otp.notice.invalid_code') }))
    )

export const disableThunk = createActionThunk('OTP_DISABLE', api('/otp/disable', { method: 'PUT' }))

export const disable = props => dispatch =>
  dispatch(disableThunk(props))
    .then(() => dispatch(toastr.add({ type: 'success', message: I18n.t('otp.notice.disabled') })))
    .catch(() =>
      dispatch(toastr.add({ type: 'error', message: I18n.t('otp.notice.invalid_password') }))
    )

export const getSecrets = createActionThunk('OTP_SECRETS', api('/otp/secrets', { method: 'POST' }))

export const getBackupCodesThunk = createActionThunk(
  'OTP_BACKUP_CODES',
  api('/otp/backup_codes', { method: 'PUT' })
)

export const getBackupCodes = props => dispatch =>
  dispatch(getBackupCodesThunk(props))
    .then(() =>
      dispatch(
        toastr.add({ type: 'success', message: I18n.t('otp.notice.backup_code_regenerated') })
      )
    )
    .catch(() =>
      dispatch(toastr.add({ type: 'error', message: I18n.t('otp.notice.invalid_password') }))
    )

export const setStage = createAction('OTP_SET_STAGE')

const initialState = { stage: '' }

export default handleActions(
  {
    [enableThunk.FAILED]: (state, action) => ({ ...state, ...action.payload }),
    [enableThunk.SUCCEEDED]: (state, action) => ({
      ...state,
      ...action.payload,
      stage: 'backup_codes'
    }),
    [disableThunk.FAILED]: (state, action) => ({ ...state, ...action.payload }),
    [disableThunk.SUCCEEDED]: () => initialState,
    [getSecrets.SUCCEEDED]: (state, action) => ({ ...state, ...action.payload }),
    [getBackupCodesThunk.FAILED]: (state, action) => ({ ...state, ...action.payload }),
    [getBackupCodesThunk.SUCCEEDED]: (state, action) => ({
      ...state,
      ...action.payload,
      stage: 'backup_codes'
    }),
    [setStage]: (state, action) => ({ ...state, stage: action.payload })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/otp.js